import AudioDownload from "./audioDownload/AudioDownloadButton";
import ChannelSync from "./channelSync/ChanelSyncButton";
import FormSubmit from './formSubmitButtons/FormSubmitButtons'
import IndividualPage from './individualPageButtons/IndividualPageButtons';
import PublicConfiguration from './public-configuration/PublicConfigurationButtons';

export default { AudioDownload, ChannelSync, FormSubmit, PublicConfiguration, IndividualPage };
